const getInterlocutorId = (thread) => thread.interlocutor.id;
const hasDocumentId = (thread) => Boolean(thread === null || thread === void 0 ? void 0 : thread.documentId);
const findThreadByInterlocutorId = (threads) => (interlocutorId) => threads.find(thread => thread.interlocutor.id === interlocutorId);
export function getUniqueThreads(threads) {
    const uniqueInterlocutorIds = [...new Set(threads.map(getInterlocutorId))];
    const findThread = findThreadByInterlocutorId(threads);
    const uniqueThreads = uniqueInterlocutorIds.map(findThread).filter(hasDocumentId);
    return uniqueThreads;
}
